import { useForm } from "@inertiajs/react";
import { Box, Container, Heading, Button, Text, Link as CLink, VStack, Input, Field, Card, Stack } from "@chakra-ui/react";
import { Link } from "@inertiajs/react";
import { useAuth } from "@/hooks/useAuth";
import { my_settings_path, my_settings_player_id_path } from "@/routes";

export default function PlayerIdEdit() {
  const player = useAuth().player!;

  const { data, setData, patch, processing, errors } = useForm({
    player_id: player.player_id,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    patch(my_settings_player_id_path());
  };

  const handlePlayerIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData("player_id", e.target.value);
  };

  return (
    <Container maxW="2xl" py={8}>
      <VStack gap={8} align="stretch">
        {/* Header */}
        <Box>
          <CLink as={Link} href={my_settings_path()} fontSize="sm">
            ← 設定に戻る{" "}
          </CLink>
          <Heading size="2xl" mt={4}>
            プレイヤーID 変更
          </Heading>
          <Text color="gray.600" mt={2}>
            あなたのユニークなプレイヤーIDを変更してください
          </Text>
        </Box>

        {/* Main Form Card */}
        <Card.Root bg="white" shadow="lg" borderRadius="xl">
          <Card.Body p={8}>
            <Box as="form" onSubmit={handleSubmit}>
              <Stack gap={6}>
                {/* Player ID */}
                <Field.Root invalid={!!errors["player_id"]}>
                  <Field.Label fontWeight="semibold" fontSize="sm">
                    プレイヤーID
                  </Field.Label>
                  <Field.HelperText color="gray.500" fontSize="xs" mb={2}>
                    半角英数字と-_.が使用できます。3文字以上20文字以内
                  </Field.HelperText>
                  <Input
                    value={data.player_id}
                    onChange={handlePlayerIdChange}
                    placeholder="例: player123"
                    autoComplete="username"
                    size="lg"
                    borderRadius="lg"
                    bg="gray.50"
                    _focus={{ bg: "white", borderColor: "blue.400", shadow: "0 0 0 1px var(--chakra-colors-blue-400)" }}
                  />
                  <Field.ErrorText>{errors["player_id"]}</Field.ErrorText>
                </Field.Root>

                {/* Submit Button */}
                <Button
                  type="submit"
                  colorPalette="blue"
                  size="xl"
                  borderRadius="xl"
                  loading={processing}
                  loadingText="変更中..."
                  _hover={{
                    transform: "translateY(-2px)",
                    shadow: "xl",
                  }}
                  transition="all 0.2s"
                  mt={4}
                >
                  変更する
                </Button>
              </Stack>
            </Box>
          </Card.Body>
        </Card.Root>
      </VStack>
    </Container>
  );
}
